const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Single%20premium%20white%20leather%20sneaker%20photographed%20on%20light%20warm%20gray%20concrete%20surface%2C%20subtle%20natural%20shadow%2C%20minimalist%20product%20photography%20with%20soft%20diffused%20daylight%2C%20clean%20modern%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20style%2C%20elegant%20negative%20space%20composition%2C%20high%20detail%20texture%20visible&width=600&height=700&seq=cat-shoes-v3&orientation=portrait",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Heavyweight%20olive%20green%20cotton%20hoodie%20neatly%20folded%20on%20light%20linen%20fabric%20surface%2C%20soft%20natural%20window%20light%20from%20right%20side%2C%20visible%20knit%20texture%20and%20drawstring%20detail%2C%20warm%20earthy%20minimalist%20aesthetic%2C%20editorial%20fashion%20flat%20lay%20photography%2C%20clean%20composition%2C%20gentle%20shadows%2C%20organic%20neutral%20tones&width=600&height=700&seq=cat-hoodies-v3&orientation=portrait",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Premium%20heavyweight%20white%20cotton%20t-shirt%20neatly%20folded%20on%20light%20warm%20beige%20surface%2C%20visible%20fabric%20texture%20and%20clean%20hem%20detail%2C%20soft%20natural%20daylight%20from%20left%2C%20minimalist%20product%20photography%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20style%2C%20elegant%20simple%20composition%2C%20gentle%20soft%20shadows&width=600&height=700&seq=cat-tshirts-v3&orientation=portrait",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-star-line",
    image: "https://readdy.ai/api/search-image?query=Classic%20olive%20bomber%20jacket%20laid%20flat%20on%20light%20warm%20stone%20gray%20surface%2C%20visible%20zipper%20detail%20and%20ribbed%20cuffs%2C%20soft%20natural%20window%20light%20from%20upper%20left%2C%20minimalist%20fashion%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20aesthetic%2C%20clean%20composition%2C%20subtle%20shadows%20highlighting%20texture&width=600&height=700&seq=cat-jackets-v3&orientation=portrait",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    image: "https://readdy.ai/api/search-image?query=Well-tailored%20beige%20chino%20pants%20folded%20neatly%20on%20light%20warm%20gray%20surface%2C%20visible%20fabric%20weave%20and%20pocket%20detail%2C%20soft%20natural%20daylight%2C%20minimalist%20product%20photography%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20style%2C%20clean%20elegant%20composition%2C%20delicate%20shadows&width=600&height=700&seq=cat-pants-v3&orientation=portrait",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-5-line",
    image: "https://readdy.ai/api/search-image?query=Classic%20black%20baseball%20cap%20photographed%20from%20front%20angle%20on%20light%20warm%20concrete%20surface%2C%20visible%20embroidery%20stitch%20detail%20on%20crown%2C%20soft%20natural%20diffused%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20streetwear%20aesthetic%2C%20clean%20composition%2C%20subtle%20shadow%20beneath%20brim&width=600&height=700&seq=cat-headwear-v3&orientation=portrait",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Coordinated%20two%20piece%20matching%20set%20in%20soft%20taupe%20color%20laid%20flat%20on%20light%20warm%20linen%20surface%2C%20sweatshirt%20and%20jogger%20pants%20arranged%20together%2C%20soft%20natural%20daylight%20from%20side%20window%2C%20minimalist%20fashion%20photography%2C%20warm%20earthy%20tones%2C%20editorial%20aesthetic%2C%20clean%20harmonious%20composition%2C%20gentle%20shadows&width=600&height=700&seq=cat-sets-v3&orientation=portrait",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-user-3-line",
    image: "https://readdy.ai/api/search-image?query=Soft%20premium%20cotton%20boxer%20briefs%20neatly%20folded%20on%20light%20warm%20beige%20fabric%20surface%2C%20visible%20elastic%20waistband%20detail%2C%20soft%20natural%20diffused%20window%20light%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20simple%20editorial%20aesthetic%2C%20delicate%20texture%20visible%2C%20gentle%20soft%20shadows&width=600&height=700&seq=cat-underwear-v3&orientation=portrait",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-trophy-line",
    image: "https://readdy.ai/api/search-image?query=Authentic%20style%20sports%20jersey%20in%20deep%20charcoal%20color%20with%20white%20numbering%20detail%20laid%20flat%20on%20light%20warm%20stone%20surface%2C%20visible%20mesh%20fabric%20texture%2C%20soft%20natural%20daylight%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20sportswear%20aesthetic%2C%20clean%20composition%2C%20subtle%20shadows&width=600&height=700&seq=cat-jersey-v3&orientation=portrait",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20watch%20with%20brown%20leather%20strap%20and%20classic%20sunglasses%20arranged%20together%20on%20light%20warm%20gray%20surface%2C%20soft%20natural%20window%20light%20reflection%20on%20glass%2C%20editorial%20fashion%20product%20photography%2C%20warm%20neutral%20tones%2C%20sophisticated%20clean%20aesthetic%2C%20subtle%20shadows%2C%20luxury%20minimal%20composition&width=600&height=700&seq=cat-accessories-v3&orientation=portrait",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    image: "https://readdy.ai/api/search-image?query=Premium%20cognac%20brown%20leather%20tote%20bag%20standing%20upright%20on%20light%20warm%20concrete%20surface%2C%20visible%20grain%20texture%20and%20gold%20hardware%2C%20soft%20natural%20daylight%20from%20left%2C%20minimalist%20product%20photography%2C%20warm%20earthy%20tones%2C%20editorial%20fashion%20aesthetic%2C%20clean%20elegant%20composition%2C%20gentle%20shadows&width=600&height=700&seq=cat-bags-v3&orientation=portrait",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-loop-left-line",
    image: "https://readdy.ai/api/search-image?query=Premium%20dark%20brown%20leather%20belt%20elegantly%20coiled%20on%20light%20warm%20stone%20surface%2C%20polished%20gold%20tone%20buckle%20detail%20visible%2C%20soft%20natural%20diffused%20window%20light%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20aesthetic%2C%20clean%20refined%20composition%2C%20subtle%20shadows%20highlighting%20leather%20texture&width=600&height=700&seq=cat-belts-v3&orientation=portrait",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20minimalist%20label%20design%20on%20light%20warm%20marble%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20reflections%20on%20glass%2C%20editorial%20beauty%20product%20photography%2C%20warm%20neutral%20tones%2C%20sophisticated%20clean%20aesthetic%2C%20subtle%20shadows%2C%20luxury%20minimal%20composition&width=600&height=700&seq=cat-perfumes-v3&orientation=portrait",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=Curated%20selection%20of%20lifestyle%20accessories%20including%20leather%20key%20holder%20ceramic%20mug%20and%20minimalist%20wallet%20arranged%20on%20light%20warm%20linen%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20product%20photography%2C%20warm%20earthy%20tones%2C%20clean%20modern%20aesthetic%2C%20harmonious%20composition%2C%20subtle%20shadows%2C%20relaxed%20aspirational%20vibe&width=600&height=700&seq=cat-other-v3&orientation=portrait",
  },
];

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-5xl font-extrabold text-foreground-950 font-heading tracking-tight mb-4">
            Shop by Category
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto">
            Browse our curated product categories and discover the best finds from the Vigorbuy Spreadsheet
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-lg bg-background-50 cursor-pointer transition-all duration-300 hover:scale-[1.02]"
              data-product-shop=""
            >
              {/* Image */}
              <div className="relative w-full h-36 md:h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - Vigorbuy Spreadsheet category`}
                  title={`${cat.name} - Vigorbuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-foreground-950/10 to-transparent"></div>
              </div>

              {/* Label */}
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`${cat.icon} text-sm text-accent-300`}></i>
                  </div>
                  <span className="text-sm md:text-base font-semibold text-background-50 whitespace-nowrap truncate">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Browse All CTA */}
        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
          >
            Browse All Categories
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}